var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-2 custom-cursor",attrs:{"headers":_vm.headers,"items":_vm.data,"hide-default-footer":"","no-data-text":_vm.noDataText,"no-results-text":_vm.noDataFound}})}
var staticRenderFns = []

export { render, staticRenderFns }